import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LaravelResourceResponse } from '../../../../../../_base-shared/contracts/laravel-response.interface';
import { User } from '../../../../../../_base-shared/models/User/User';
import { MainGlobalEventService } from '../../../_shared/services/main-global-event.service';


@Component({
  standalone: false,
  selector:    'app-user-editor',
  templateUrl: './user-editor.component.html',
  styles:      [],
})
export class UserEditorComponent implements OnInit {
  public authUser: User;
  public editorType: 'create' | 'edit';
  public userId: number = null;
  public submitting: boolean;
  public serverResponse: LaravelResourceResponse;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private globalEventsService: MainGlobalEventService) {
  }

  ngOnInit(): void {
    this.globalEventsService.authUser$.subscribe(user => {
      this.authUser = user;
      if (this.authUser) {
        this.userId = +this.route.snapshot.paramMap.get('id');
        if (this.userId) {
          this.editorType = 'edit';
        } else {
          this.editorType = 'create';
          this.userId     = null;
        }
      }
    });
  }

  public isActive(route: string): boolean {
    return this.router.isActive('users/' + this.userId + '/edit/' + route, false);
  }
}
